import { useParams } from 'react-router-dom'
import { TableComponentProps } from '../../../../../../../baseComponents/TwinTable/BaseScreenTable/types'
import { InputTableURLsTable } from '../../../../../../../baseComponents/TwinTable/InputTableLayout/types'
import useOrderScreenLogic from '../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/useOrderScreenLogic'
import { BuyOrderStatusInversed } from '@teinor/erp/types/company/order/buy/buyOrder'
import BuyOrderCreateStep from './Steps/BuyOrderCreateStep'
import { permissionCheck } from '../../../../../../../baseComponents/PermissionChecker/function'
import { getUserPermissions } from '../../../../../../../utils/reducers/getters'
import BuyOrderWaitingResponseStep from './Steps/BuyOrderWaitingResponseStep'
import BuyOrderFinishedStep from './Steps/BuyOrderFinishedStep'
import BuyOrderCreateNoPermissionStep from './Steps/BuyOrderCreateNoPermissionsStep'
import { extractWhereFormCompleteDataFilters } from '../../../../../../../utils/hooks/orders/useExtractWhereFormCompleteDatafilters'
import { SpecificPriceRulesPayload } from '../../../../../../../utils/reducers/products/specificPriceRules'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../../utils/reducers'
import withLoading from '../../../../../../../utils/hoc/withLoading'


type SingleBuyOrderProps = TableComponentProps & ReduxSingleBuyOrder & { }

const SingleBuyOrder: React.FC<SingleBuyOrderProps> = ({ userPermissions, specificPriceRules }) => {
    const params = useParams<{ id: string }>()
    const OrderId = params.id

    const inputTableURLs: InputTableURLsTable = {
        createData: ['/api/app/order/buy/buyOrder/orderProduct/createBuyOrderProduct', { OrderId }],
        getData: ['/api/app/order/buy/buyOrder/getBuyOrderComplete', { id: OrderId }],
        updateData: '/api/app/order/buy/buyOrder/orderProduct/updateBuyOrderProduct',
        delete: '/api/app/order/buy/buyOrder/orderProduct/deleteBuyOrderProduct',
        updateHeaderData: '/api/app/order/buy/buyOrder/updateBuyOrder',
        updateOrderLines: '/api/app/order/buy/buyOrder/updateBuyOrderNLines',
        getSubProducts: ['/api/app/order/buy/buyOrder/orderProduct/getAllSubBuyOrderProducts', ['SupplierId']],
        printTags: '/api/app/order/buy/buyOrder/printBuyOrderTags'
    }
    const defaultSpecificPriceRuleId = specificPriceRules?.defaultSpecificPriceRuleId
    const { completeData, setCompleteData, getCompleteData, tableConfiguration, setTableConfiguration, headerChanges } = useOrderScreenLogic({ inputTableURLs, userPermissions: 'buy.order', extractWhereFormCompleteDataFilters, defaultSpecificPriceRuleId })
    const status = parseInt(completeData?.header.status)
    if (!permissionCheck(getUserPermissions('buy.order'), 'update') || completeData?.header.hidePrices || completeData?.header.notModificable) {
        return <BuyOrderCreateNoPermissionStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }else if (status === BuyOrderStatusInversed['waitingResponse']) {
        return <BuyOrderWaitingResponseStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    } else if (status === BuyOrderStatusInversed['denied'] || status === BuyOrderStatusInversed['accepted']) {
        return <BuyOrderFinishedStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
    }
    return <BuyOrderCreateStep {...{ completeData, setCompleteData, getCompleteData, inputTableURLs, userPermissions, tableConfiguration, setTableConfiguration, headerChanges }} />
}


const singleBuyOrderDispatch = {
    setSpecificPriceRules: (payload: SpecificPriceRulesPayload) => ({ type: 'CHANGE_SPECIFICPRICERULES', payload }),
}

export type ReduxSingleBuyOrder = ConnectedProps<typeof singleBuyOrderConnect>
const mapSingleBuyOrderConnector = (state: AllReduxPayloads) => ({ specificPriceRules: state.specificPriceRules })
const singleBuyOrderConnect = connect(mapSingleBuyOrderConnector, singleBuyOrderDispatch)
const singleBuyOrderConnectLoading = withLoading(SingleBuyOrder, [{ fetchUrl: '/api/app/product/specificPrice/getAllSpecificPriceRules', propName: 'specificPriceRules', setFunctionName: 'setSpecificPriceRules' }])
const SingleBuyOrderConnect = singleBuyOrderConnect(singleBuyOrderConnectLoading)

export default SingleBuyOrderConnect